import type { PhonemeType } from "../../../generated/graphql";
import { PhonemeCard } from "./PhonemeCard";

interface PhonemeGroup {
  id: string;
  phoneme: string;
  phonemeType: string;
  tags: string[];
  audioCount: number;
}

interface PhonemeTypeSectionProps {
  phonemeType: PhonemeType;
  label: string;
  groups: PhonemeGroup[];
}

export function PhonemeTypeSection({ label, groups }: PhonemeTypeSectionProps) {
  return (
    <div>
      <h2 className="mb-4 text-lg font-semibold text-gray-900">{label}</h2>
      <div className="grid grid-cols-2 gap-4 xl:grid-cols-9">
        {groups.map((group) => (
          <PhonemeCard key={group.phoneme} group={group} />
        ))}
      </div>
    </div>
  );
}
